import React, { Component } from "react";
import { Row, Col, Form, Icon, Input, Button, message } from "antd";
import { Parse } from "parse";

import FormItem from "antd/lib/form/FormItem";
import { ColShadow } from "../Constants/style";

import MainHeader from "../Header/header";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = { redirect: false };
  }

  handleSubmit = e => {
    var ctx = this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        Parse.User.requestPasswordReset(values.email)
          .then(() => {
            // Password reset request was sent successfully
            message.success("Email envoyé ! Vérifiez votre boîte mail");
            ctx.setState({ redirect: true });
          })
          .catch(error => {
            console.log("err: ", error)
            // Show the error message somewhere
            message.error("Votre adresse email n'a pas été trouvée.");
          });
      } else message.error("Adresse email incorrecte");
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div
        style={{
          height: "100vh",
          minHeight: "100vh",
          backgroundColor: "#F0F2F5"
        }}
      >
        <MainHeader />
        <Row
          style={{
            marginLeft: "20%",
            marginRight: "20%",
            marginBottom: "10%",
            marginTop: "5%"
          }}
          justify="center"
          align="middle"
        >
          <ColShadow
            style={{
              width: "100%",
              background: "#fff",
              padding: 24,
              radius: 4
            }}
            xs={24}
            lg={6}
            xl={5}
          >
            <Row
              style={{ textAlign: "center" }}
              justify="center"
              align="middle"
            >
              <h4>Vous avez oublié votre mot de passe ?</h4>
              <p>
                Pas de panique, vous n'avez qu'à renseigner votre adresse email,
                nous vous enverrons un mail afin que vous puissiez le
                réinitialiser.
              </p>
            </Row>
            <Row style={{ padding: "10px" }}>
              <Col
                style={{ paddingLeft: "30%", paddingRight: "30%" }}
                justify="center"
                align="middle"
              >
                <Form onSubmit={this.handleSubmit}>
                  <FormItem>
                    {getFieldDecorator("email", {
                      rules: [
                        {
                          type: "email",
                          message: "Ce format d'email n'est pas valide !"
                        },
                        {
                          required: true,
                          message: "Indique ton adresse email"
                        }
                      ]
                    })(
                      <Input
                        placeholder="Adresse mail"
                        style={{ marginTop: "7%" }}
                        prefix={
                          <Icon
                            type="mail"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                      />
                    )}

                    <Button
                      type="primary"
                      style={{ marginTop: "7%" }}
                      htmlType="submit"
                    >
                      Envoyer
                    </Button>
                  </FormItem>
                </Form>
              </Col>
            </Row>
          </ColShadow>
        </Row>
      </div>
    );
  }
}
const ForgotPasswordForm = Form.create()(ForgotPassword);

export default ForgotPasswordForm;
